import { IPropertyInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { ITypeInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/EntityBaseProperties";
import { ISoftDeletableEntityProperties, SoftDeletableEntityProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/SoftDeletableEntityProperties";

export interface ICaseCancellationPostponementProperties extends IEntityBaseProperties, ISoftDeletableEntityProperties
{

    // #region Basic Properties

    caseId: IPropertyInfoMetadata;
    typeLookupItemId: IPropertyInfoMetadata;
    cancellationReasonLookupItemId: IPropertyInfoMetadata;
    postponementReasonLookupItemId: IPropertyInfoMetadata;
    reasonDescription: IPropertyInfoMetadata;
    notificationDate: IPropertyInfoMetadata;
    mediationDate: IPropertyInfoMetadata;
    assignedMediatorName: IPropertyInfoMetadata;
    meetingOutcomeComboDropDownId: IPropertyInfoMetadata;
    closedDate: IPropertyInfoMetadata;
    localAuthorityContractChargeCodeId: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Properties

    case: IPropertyInfoMetadata;
    meetingOutcome: IPropertyInfoMetadata;
    localAuthorityContractChargeCode: IPropertyInfoMetadata;
    cancellationReasonLookupItem: IPropertyInfoMetadata;
    postponementReasonLookupItem: IPropertyInfoMetadata;
    typeLookupItem: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Collection Properties

    caseInvoiceItems: IPropertyInfoMetadata;

    // #endregion

}

export const CaseCancellationPostponement: ITypeInfoMetadata<ICaseCancellationPostponementProperties> = {
    attributes: [
        {
            id: "{0230CD95-D64A-4F9A-B970-033AF79556CE}",
            $type: "SeriouslyRAD.Framework.ClientAwareIdAttribute, SeriouslyRAD.Framework"
        },
        {
            name: "CaseCancellationPostponement",
            nameFriendly: "Case Cancellation / Postponement",
            namePlural: "CaseCancellationPostponements",
            namePluralFriendly: "Case Cancellations / Postponements",
            $type: "SeriouslyRAD.Framework.ClientAwareNameAttribute, SeriouslyRAD.Framework"
        }
    ],
    classHierarchy: [
        "GlobalMediation.Data.Entities.CaseCancellationPostponement, GlobalMediation.Data.Entities",
        "SeriouslyRAD.Framework.Data.EntityBase, SeriouslyRAD.Framework.Data.Entities",
        "System.Object, System.Private.CoreLib"
    ],
    hasEnumFlags: false,
    name: "CaseCancellationPostponement",
    properties: {
        ...EntityBaseProperties,
        ...SoftDeletableEntityProperties,
        caseId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Case"
                },
                {
                    entityDescriptionProperty: "ListDescription",
                    entityName: "Case",
                    entityNameFriendly: "Case",
                    entityNamePlural: "Cases",
                    entityNamePluralFriendly: "Cases",
                    foreignEntityAlias: "CaseCancellationsAndPostponements",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+CaseIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 0
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        typeLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Type"
                },
                {
                    foreignEntityAlias: "CaseCancellationPostponementsByType",
                    typeDescription: "Case Cancellation / Postponement Types",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+TypeLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 1
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TypeLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cancellationReasonLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Cancellation Reason"
                },
                {
                    foreignEntityAlias: "CaseCancellationPostponementsByCancellationReason",
                    typeDescription: "Case Meeting Cancellation Reasons",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+CancellationReasonLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "TypeLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "9119d9b1-dbfd-4bc8-be8f-65164a0990a4",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+CancellationReasonLookupItemIdRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 2
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CancellationReasonLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        postponementReasonLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Postponement Reason"
                },
                {
                    foreignEntityAlias: "CaseCancellationPostponementsByPostponementReason",
                    typeDescription: "Case Meeting Postponement Reasons",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+PostponementReasonLookupItemIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "TypeLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "f05ec763-79ff-42c6-a59e-66ca03774529",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+PostponementReasonLookupItemIdRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 3
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PostponementReasonLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        reasonDescription: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Reason Description"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 4
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ReasonDescription",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        notificationDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Notification Date"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+NotificationDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 5
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "NotificationDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        mediationDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Mediation Date"
                },
                {
                    evaluator: {
                        propertyName: "TypeLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "f05ec763-79ff-42c6-a59e-66ca03774529",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+MediationDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 6
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MediationDate",
            propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        assignedMediatorName: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Assigned Mediator Name"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 7
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 256,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "AssignedMediatorName",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingOutcomeComboDropDownId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Meeting Outcome"
                },
                {
                    entityDescriptionProperty: "TextValue1",
                    entityName: "ComboDropdown",
                    entityNameFriendly: "Combo Dropdown",
                    entityNamePlural: "ComboDropdowns",
                    entityNamePluralFriendly: "Combo Dropdowns",
                    foreignEntityAlias: "CaseCancellationPostponementsByMeetingOutcome",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+MeetingOutcomeComboDropDownIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "TypeLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "9119d9b1-dbfd-4bc8-be8f-65164a0990a4",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+MeetingOutcomeComboDropDownIdRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 8
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MeetingOutcomeComboDropDownId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        closedDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Date Closed"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+ClosedDateMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    blankIfNotRelevant: true,
                    evaluator: {
                        propertyName: "TypeLookupItemId",
                        comparerId: "d79b155a-56a3-41dd-870a-ecf83a0740c5",
                        propertyValue: "9119d9b1-dbfd-4bc8-be8f-65164a0990a4",
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.PropertyEvaluator`1[[System.Guid, System.Private.CoreLib]], SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareRelevantEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+ClosedDateRelevantEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 9
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "ClosedDate",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityContractChargeCodeId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Local Authority Contract Charge Code"
                },
                {
                    entityDescriptionProperty: "ListDescription",
                    entityName: "LocalAuthorityContractChargeCode",
                    entityNameFriendly: "Local Authority Contract Charge Code",
                    entityNamePlural: "LocalAuthorityContractChargeCodes",
                    entityNamePluralFriendly: "Local Authority Contract Charge Codes",
                    foreignEntityAlias: "CaseCancellationsPostponements",
                    entityFilter: "localAuthorityContract/cases/any(item1:item1/id eq [caseId])",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareEntityIdAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseCancellationPostponement+LocalAuthorityContractChargeCodeIdMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 10
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityContractChargeCodeId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        cancellationReasonLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CancellationReasonLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        case: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Case",
            propertyTypeId: "GlobalMediation.Data.Entities.Case, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseInvoiceItems: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseInvoiceItems",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseInvoiceItem, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        localAuthorityContractChargeCode: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "LocalAuthorityContractChargeCode",
            propertyTypeId: "GlobalMediation.Data.Entities.LocalAuthorityContractChargeCode, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingOutcome: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "MeetingOutcome",
            propertyTypeId: "GlobalMediation.Data.Entities.ComboDropdown, GlobalMediation.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        postponementReasonLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "PostponementReasonLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        typeLookupItem: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "TypeLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        }
    },
    underlyingTypeId: "GlobalMediation.Data.Entities.CaseCancellationPostponement, GlobalMediation.Data.Entities",
    $type: "SeriouslyRAD.Framework.Reflection.TypeInfoMetadata, SeriouslyRAD.Framework"
};

